"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ThumbsUp_1 = require("../svgs/ThumbsUp");
var ThumbsDown_1 = require("../svgs/ThumbsDown");
var Footer = function Footer(_a) {
  var feedback = _a.feedback,
    thumbsUp = _a.thumbsUp,
    thumbsDown = _a.thumbsDown;
  return React.createElement("div", {
    className: 'total-home-score-footer'
  }, "Are these scores helpful to you?", React.createElement("div", {
    onClick: function onClick() {
      return feedback(true);
    }
  }, React.createElement(ThumbsUp_1.ThumbsUp, {
    className: thumbsUp
  })), React.createElement("div", {
    onClick: function onClick() {
      return feedback(false);
    }
  }, React.createElement(ThumbsDown_1.ThumbsDown, {
    className: thumbsDown
  })));
};
exports.Footer = Footer;